import React, { useState } from 'react';
import {
  Collapse,
  StepContent,
  StepLabel,
  Stepper,
  Typography
} from '@mui/material';
import { toast } from 'react-toastify';

//API
import { packingTrackingHistoryApi } from '@/main/api';

//SERVICES
import { GetPrintPdfTagRequest } from '@/main/models/request/packingTrackingHistoryResquest';
import {
  GetByIdPackingTrackingResponse,
  IHistory
} from '@/main/models/response/packingTrackingHistoryResponse';
import { FileTypeContentEnum } from '@/main/services/enum/FileTypeContentEnum';
import { getTranslateByKey } from '@/main/services/utils';
import { userIsAdmin, userIsSupplier } from '@/main/services/utilsUser';
import { downloadAnyFile, downloadPdfFile } from '@/main/services/utilsFile';

//COMPONENTS
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';

import * as S from './styles';
import { OrderStatusEnum } from '@/main/services/enum/OrderStatusEnum';
import { handleDownloadPDf, handleDownloadZPL } from '../../infoOrder/utilsInfoOrder';

function getSteps() {
  return [
    getTranslateByKey('procurementstatus.transit'),
    getTranslateByKey('procurementstatus.delivered')
  ];
}

interface SeeShippingDetails {
  isLoadingDataSeeShippingDetails: boolean;
  checked: boolean;
  dataSeeShippingDetails: GetByIdPackingTrackingResponse[];
  trackingNumber: string;
}

function SeeShippingDetails({
  isLoadingDataSeeShippingDetails,
  checked,
  dataSeeShippingDetails,
  trackingNumber
}: SeeShippingDetails) {
  const steps = getSteps();
  const [loadingZpl, setLoadingZpl] = useState<boolean>(false);
  const [loadingPdf, setLoadingPdf] = useState<boolean>(false);

  const isAdmin = userIsAdmin();
  const isSupplier = userIsSupplier();

  async function handlePDf() {
    setLoadingPdf(true);
    const request = {
      packingTrackingCode: trackingNumber,
      is4x6: true
    } as GetPrintPdfTagRequest;
    packingTrackingHistoryApi
      .getPrintPdfTag(request)
      .then(res => {
        const resData = res.data.result;
        downloadPdfFile(resData.content, `tag${trackingNumber}.pdf`);
      })
      .catch(() => { })
      .finally(() => setLoadingPdf(false));
  }

  function handleZPL() {
    setLoadingZpl(true);
    packingTrackingHistoryApi
      .getPrintZplTag(trackingNumber)
      .then(res => {
        const resData = res.data.result;
        downloadAnyFile(
          resData.content,
          `tag${trackingNumber}.zpl`,
          FileTypeContentEnum.ZPL
        );
      })
      .catch(() => { })
      .finally(() => setLoadingZpl(false));
  }

  function renderHistory(list: IHistory) {
    let historyText = `${list.historyDateFormatted} - ${list.description}`;
    if (list.additionalInformation) {
      historyText += `(${list.additionalInformation})`;
    }
    return historyText;
  }

  if (isLoadingDataSeeShippingDetails) return <LoadingComponent />;

  return (
    <>
      <S.Container>
        <div>
          <Collapse in={checked}>
            <Stepper orientation="vertical">
              {dataSeeShippingDetails.map((option, key) => (
                <S.ContainerStep
                  lastStep={
                    option.idProcurementStatus != OrderStatusEnum.Delivered
                  }
                  active={true}
                  key={key}
                  className="TesteStep">
                  <StepLabel>{option.procurementStatusDescription}</StepLabel>
                  <StepContent>
                    <S.BoxSeeShippingDetails>
                      {option.history.map((list: IHistory) => (
                        <Typography>{renderHistory(list)}</Typography>
                      ))}
                    </S.BoxSeeShippingDetails>
                  </StepContent>
                </S.ContainerStep>
              ))}
            </Stepper>

            {(isSupplier || isAdmin) &&
              dataSeeShippingDetails.length === OrderStatusEnum.Assigned && (
                <S.ContainerButton>
                  <SecondaryButton
                    type="button"
                    onClick={() => handleDownloadPDf(trackingNumber, setLoadingPdf)}
                    id="id-searchOrders-button-printPdf"
                    isLoading={loadingPdf}>
                    {getTranslateByKey('packingTrackingHistory.printTagPDF')}
                  </SecondaryButton>
                  <SecondaryButton
                    type="button"
                    onClick={() => handleDownloadZPL(trackingNumber, setLoadingZpl)}
                    id="id-searchOrders-button-printZpl"
                    isLoading={loadingZpl}>
                    {getTranslateByKey('packingTrackingHistory.printTagZPL')}
                  </SecondaryButton>
                </S.ContainerButton>
              )}
          </Collapse>
        </div>
      </S.Container>
    </>
  );
}

export default SeeShippingDetails;
